var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.845,34.165c0.253-0.511,0.193-1.122-0.152-1.575l-14.5-19c-0.568-0.744-1.816-0.744-2.385,0l-14.5,19 c-0.346,0.453-0.405,1.064-0.152,1.575C8.408,34.677,8.93,35,9.5,35h29C39.07,35,39.592,34.677,39.845,34.165z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SortUp);
export default __webpack_public_path__ + "static/media/icons8-sort-up.a6525b514515bcc732ec30cba4bf3881.svg";
export { ForwardRef as ReactComponent };